import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Camera, X } from "@phosphor-icons/react";
import { useAuth } from "../contexts/AuthContext";

const DISMISS_KEY = "wta:verifyFaceBannerDismissed";

export default function VerifyFaceBanner({ compact = false }) {
    const { user } = useAuth();
    const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === "1");

    // Reset dismissal when user verifies in another tab
    useEffect(() => {
        if (user?.voting_eligible) sessionStorage.removeItem(DISMISS_KEY);
    }, [user?.voting_eligible]);

    if (!user || user.voting_eligible || dismissed) return null;

    const onDismiss = () => {
        sessionStorage.setItem(DISMISS_KEY, "1");
        setDismissed(true);
    };

    return (
        <div
            data-testid="verify-face-banner"
            className={`flex items-center gap-3 bg-wta-primary/10 border border-wta-primary/40 text-white ${compact ? "px-3 py-2 text-xs" : "px-4 py-3 text-sm"} rounded-sm`}
        >
            <Camera size={compact ? 16 : 20} weight="fill" className="text-wta-primary shrink-0" />
            <div className="flex-1 leading-snug">
                <span className="font-heading tracking-wider uppercase text-wta-primary">Verify your face</span>
                <span className="text-wta-muted"> — required before you can vote on performances.</span>
            </div>
            <Link
                to="/verify-face"
                data-testid="verify-face-banner-cta"
                className="font-heading uppercase tracking-wider text-xs px-3 py-1.5 bg-wta-primary text-black rounded-sm hover:opacity-90 shrink-0"
            >
                Verify
            </Link>
            <button
                data-testid="verify-face-banner-dismiss"
                onClick={onDismiss}
                className="text-wta-muted hover:text-white shrink-0"
                aria-label="Dismiss"
            >
                <X size={14} />
            </button>
        </div>
    );
}
